import { useEffect } from "react";
import { useApp } from "../../../services/app-context";

export function OktaLogin() {
  const { tenantProfile } = useApp();
  const handleLogin = async () => {
    window.location.href = tenantProfile?.sso_redirect_url;
  };

  useEffect(() => {
    handleLogin();
  }, []);

  return null;
}
